"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ReadCircleIcon = ({ className }) => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ className: className, width: "8", height: "9", viewBox: "0 0 8 9", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("circle", { cx: "4", cy: "4.5", r: "4", fill: "#337ACE" }, void 0) }), void 0));
exports.default = ReadCircleIcon;
